import React from "react";
import { Icons } from "components";

export default function RatingStars({ rate }) {
  const renderRate = React.useMemo(() => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <Icons.Star
          key={i}
          fill={i <= rate ? "#ffcc00" : "#0000"}
          stroke="#ffcc00"
          className="svg-fill"
          width="15"
        />
      );
    }
    return stars;
  }, [rate]);
  return renderRate;
}
